export const getCurrentCustomer = (state: {currentCustomer: any}) => {
    return state.currentCustomer;
};

export const getCurrentPartner = (state: {currentPartner: any}) => {
    return state.currentPartner;
};
